module.exports = __webpack_public_path__ + "media/images/pic/authors/marta-klimiuk-352cdf1e76dd82157b5bc399ee2e2516.png";